import { usingGet, usingPost, usingPut, usingUpload, usingDelete } from '@ocean/api'
import {
  AddVirtualEventTaskModel,
  UpdateVirtualEventTaskModel,
  AddVirtualEventTaskWithFileModel,
  Availability,
} from 'modules/virtualClassrooms/manager/EventDetails/types/tasksAndResources'

export const getListVirtualEventTasks = (eventId: Guid) =>
  usingGet(`VirtualEvents/ListVirtualEventTasks?eventId=${eventId}`)

export const getVirtualEventTask = (taskId: Guid) =>
  usingGet(`VirtualEvents/GetVirtualEventTask?taskId=${taskId}`)

export const deleteVirtualEventTasks = (taskIds: string[]) =>
  usingPost('VirtualEvents/DeleteVirtualEventTasks', { taskIds })

export const addVirtualEventTask = (formData: AddVirtualEventTaskModel) =>
  usingPost('VirtualEvents/AddVirtualEventTask', formData)

export const updateVirtualEventTask = (formData: UpdateVirtualEventTaskModel) => {
  const { taskId, ...rest } = formData
  return usingPut(`VirtualEvents/UpdateVirtualEventTask?taskId=${taskId}`, rest)
}

export const addVirtualEventTaskWithFile = (formData: AddVirtualEventTaskWithFileModel) => {
  const { file, ...rest } = formData
  const data = new FormData()
  data.append('BinaryMetadata', JSON.stringify(rest))
  data.append('BinaryData', file)
  return usingUpload('VirtualEvents/AddVirtualEventTaskFile', data)
}

export const getListSurveys = () => usingGet('Surveys/ListSurveys?includeInactive=false')

export const getListElearnings = () => usingGet('Elearnings/ListElearnings')

export const getListRapidElearnings = () => usingGet('RapidElearnings/ListRapidElearnings')

export const getCrewEvaluationReferences = () =>
  usingGet('CrewEvaluation/References', { useProxy: true })

export const getCrewEvaluationTestDefinitions = () =>
  usingGet(
    'CrewEvaluation/ListCrewEvaluationTestDefinitions?includeModified=false&includePublished=true'
  )

export const getCrewEvaluationStcwTestCriteria = () =>
  usingGet('CrewEvaluation/ListCrewEvaluationStcwTestCriteria')

export const getCrewEvaluationDetailedTestCriteria = () =>
  usingGet('CrewEvaluation/ListCrewEvaluationDetailedTestCriteria')

export const getListVirtualEventPresentationFiles = (eventId: Guid) =>
  usingGet(`VirtualEvents/ListVirtualEventPresentationFiles?eventId=${eventId}`)

export const uploadVirtualEventPresentationFile = (eventId: Guid, file: File) => {
  const input = { eventId }
  const formData = new FormData()
  formData.append('BinaryMetadata', JSON.stringify(input))
  formData.append('BinaryData', file)
  return usingUpload('VirtualEvents/UploadVirtualEventPresentationFile', formData)
}

export const deleteVirtualEventPresentationFile = (fileId: Guid) =>
  usingDelete(`VirtualEvents/DeleteVirtualEventPresentationFile?fileId=${fileId}`)

export const updateVirtualEventPresentationFile = (fileId: Guid, availability: Availability) =>
  usingPost('VirtualEvents/UpdateVirtualEventPresentationFile', {
    fileId,
    availability,
  })
